import { useQuery } from "@tanstack/react-query";
import { formatAmountWithCommas } from "@unified-checkout/design-system";
import type { ITransactionsDateRange, ITransactionsStatusFilter } from "@app/dashboard/types/innerLayout/transactions";
import type { IMetrics } from "@app/dashboard/types/innerLayout/metrics";
import { QUERY_KEYS } from "@app/dashboard/constants/query-keys";
import { useTestLiveModeStore } from "@app/dashboard/store/testLiveMode";
import { useLangStore } from "@app/dashboard/store/lang";
import { getMetricCardsData } from "@app/dashboard/services/inner_layout/transactions/metric-cards";
import { Metrics } from "@app/dashboard/components/inner_layout/Metrics";
import styles from "./metrics-box.module.scss";

export const MetricsBox = ({
  dateRange,
  comparedRangeText,
  appliedTransactionsStatus,
}: {
  dateRange: ITransactionsDateRange,
  comparedRangeText: string,
  appliedTransactionsStatus: ITransactionsStatusFilter['name'],
}) => {
  const { lang } = useLangStore();
  const { isLive } = useTestLiveModeStore();

  const {
    isLoading,
    isError,
    data: metricsData
  } = useQuery({
    queryKey: [
      QUERY_KEYS.GET_TRANSACTIONS_METRIC_CARDS_DATA,
      dateRange,
      appliedTransactionsStatus,
      isLive
    ],
    queryFn: () => getMetricCardsData({ isLive, dateRange, status: appliedTransactionsStatus }),
    enabled: Object.values(dateRange || {}).every(value => !!value)
  });

  const metricCardsData: IMetrics['data'] = (Object.values(metricsData?.data?.data || {})).map((metricCard: any) => {

    const { value, percentage_change } = metricCard || {};
    const { status, percentage } = percentage_change || {};

    return {
      currency: metricCard?.[`${lang}_currency`],
      title: metricCard?.[`${lang}_title`],
      value: metricCard?.[`${lang}_currency`] ? formatAmountWithCommas({ amount: value, keepDecimals: true, excludeZeroDecimals: true, currency: metricCard?.[`en_currency`] }) : value,
      comparison: {
        status: status,
        percentage: percentage
      }
    }
  })

  return (
    <div className={styles["metrics-box"]}>

      <Metrics
        comparisonRangeName={comparedRangeText || ''}
        data={metricCardsData.length ? metricCardsData : undefined}
        noOfCards={3}
        isError={isError}
        isLoading={isLoading}
      />

    </div>
  )
}